"use client";

import clsx from "clsx";
import type React from "react";
import { useEffect, useState } from "react";
import styles from "./Overlay.module.scss";

export interface OverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  visible?: boolean;
  showDelay?: number;
}

const Overlay = (props: OverlayProps) => {
  const { visible, className, showDelay, ...otherProps } = props;
  const [delayedVisible, setDelayedVisible] = useState(visible);

  useEffect(() => {
    if (!showDelay) {
      setDelayedVisible(visible ?? false);
      return;
    }

    let timeoutId: NodeJS.Timeout;

    if (visible) {
      timeoutId = setTimeout(() => {
        setDelayedVisible(true);
      }, showDelay);
    } else {
      setDelayedVisible(false);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [visible, showDelay]);

  return (
    <div
      {...otherProps}
      className={clsx(styles.overlay, className)}
      data-visible={delayedVisible}
    />
  );
};

export default Overlay;
